import React from 'react';

import styles from './pixels.module.scss';

export const Pixel = ({ url }: { url: string }) => (
  <div className={styles.pixel}>
    <img src={url} alt="" className={styles.pixelImg} key={`pixel-${url}`} />
  </div>
);
